import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import AuthInfoPage, {
  ButtonContainer,
  Message,
  Spinner,
} from 'components/AuthInfoPage';
import CustomButton from 'components/Button';
import { SubscribeAPI } from 'services/subscribe.api';

export default function InvalidFirstLoginLink() {
  const { t } = useTranslation();
  const { search } = useLocation();
  const resendToken = new URLSearchParams(search).get('resendToken') || '';
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleResend = async () => {
    if (!resendToken || isLoading) return;
    setIsLoading(true);
    try {
      await SubscribeAPI.resendFirstLoginEmail(resendToken);
    } finally {
      setIsLoading(false);
      setIsSent(true);
    }
  };

  return (
    <AuthInfoPage title={t('auth.linkExpired.title')}>
      {isSent ? (
        <Message variant="body2">{t('auth.linkExpired.emailSent')}</Message>
      ) : (
        <>
          <Message variant="body2">{t('auth.linkExpired.message')}</Message>
          <ButtonContainer>
            <CustomButton onClick={handleResend} disabled={isLoading || !resendToken}>
              {isLoading && <Spinner size="2.5rem" />}
              {t('auth.linkExpired.resendButton')}
            </CustomButton>
          </ButtonContainer>
        </>
      )}
    </AuthInfoPage>
  );
}
